import { render, staticRenderFns } from "./ProductTroubleshoot.vue?vue&type=template&id=130ed5e8&scoped=true"
import script from "./ProductTroubleshoot.vue?vue&type=script&lang=js"
export * from "./ProductTroubleshoot.vue?vue&type=script&lang=js"
import style0 from "./ProductTroubleshoot.vue?vue&type=style&index=0&id=130ed5e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ed5e8",
  null
  
)

export default component.exports